// extracted by mini-css-extract-plugin
export var infoRow = "_q9-2";
export var labelContainer = "_q9-0";
export var rightInfo = "_q9-1";